import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  IconButton,
  useMediaQuery,
  useTheme,
  Grid,
} from "@mui/material";
import DeleteIcon from "@material-ui/icons/Delete";
import { CreateTwoTone } from "@material-ui/icons";
import { Button } from "@mui/material";
import logo from "./logo.png";
import { useNavigate } from "react-router-dom";
import Formservice from "./../service/Formservice";
import PGIService from "./../service/PGIService";
import Message from "./Message";
import { useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Menu from "./Menu";
import { LoadingButton } from "@mui/lab";
import Identifiant from "./reusable/Identifiant";
import NB from "./reusable/NB";

function Competence() {
  const location = useLocation();
  const [submitting, setSubmitting] = useState(false);
  //const params = new URLSearchParams(location.search);
  const ref = localStorage.getItem("ref");
  const [compt, setCompt] = useState([]);
  const parts = ref.split("_");
  const prefix = parts[0];
  const [is, setIS] = useState(0);

  const [opens, setOpens] = React.useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const handleClose = () => {
    setOpens(false);
  };

  const handleUp = () => {
    PGIService.updateCompetence(is, modif)
      .then((result) => {
        if (result.status) {
          setMessage({
            ...message,
            open: true,
            color: "green",
            messageInfo: "Succès",
          });
          Formservice.details(ref).then((result) => {
            if (result && result.data) {
              setIdentif(result.data);
              setCompt(result.autreep);
            } else {
            }
          });
          setOpens(false);
        } else {
          setMessage({
            ...message,
            open: true,
            color: "red",
            messageInfo: "Erreur",
          });
        }
      })
      .catch((err) => {
        setMessage({
          ...message,
          open: true,
          color: "red",
          messageInfo: "erreur",
        });
      });
  };

  const [message, setMessage] = React.useState({
    open: false,
    color: "green",
    messageInfo: "",
  });
  const { open, color, messageInfo } = message;
  const [form, setForm] = useState({
    id_poste: "",
    email: "",
  });
  const initialLanguages = [
    {
      competence: "Langue",
      type: "Français",
      lire: false,
      ecrire: false,
      parler: false,
    },
    {
      competence: "Langue",
      type: "Anglais",
      lire: false,
      ecrire: false,
      parler: false,
    },
  ];
  const [languages, setLanguages] = useState(initialLanguages);

  const handleCheckboxChange = (index, field) => {
    const newLanguages = [...languages];
    if (field === "lire") {
      newLanguages[index].lire = !newLanguages[index].lire;
    } else if (field === "ecrire") {
      newLanguages[index].ecrire = !newLanguages[index].ecrire;
    } else if (field === "parler") {
      newLanguages[index].parler = !newLanguages[index].parler;
    }
    setLanguages(newLanguages);
  };

  const initialInformatique = [
    {
      competence: "Informatique",
      type: "Excel,Word, PowerPoint,Outlook",
      Excelent: false,
      Moyen: false,
      Débutant: false,
    },
    {
      competence: "Informatique",
      type: "Internet, mailing",
      Excelent: false,
      Moyen: false,
      Débutant: false,
    },
  ];
  const [informatique, setInformatique] = useState(initialInformatique);

  const handleCheckboxChangeinfo = (index, field) => {
    const newLanguages = [...informatique];
    if (field === "Excellent") {
      console.log("aaa");
      newLanguages[index].Excelent = !newLanguages[index].Excelent;
      newLanguages[index].Moyen = false;
      newLanguages[index].Débutant = false;
    } else if (field === "Moyen") {
      newLanguages[index].Excelent = false;
      newLanguages[index].Moyen = !newLanguages[index].Moyen;
      newLanguages[index].Débutant = false;
    } else if (field === "Débutant") {
      newLanguages[index].Excelent = false;
      newLanguages[index].Moyen = false;
      newLanguages[index].Débutant = !newLanguages[index].Moyen;
    }
    setInformatique(newLanguages);
  };
  const navigate = useNavigate();

  const initialRows = [
    { domaine: "", competence: "", niveau: "" },
    { domaine: "", competence: "", niveau: "" },
  ];

  const handleChange = (index, field, value) => {
    const newRows = [...rows];
    newRows[index] = { ...newRows[index], [field]: value };
    setRows(newRows);
  };

  const [rows, setRows] = useState(initialRows);

  const handleretour = () => {
    navigate("/competence");
  };

  const handleenvoie = () => {
    setSubmitting(true);
    Formservice.saveautrecompetence(rows, informatique, languages, ref)
      .then((result) => {
        if (result.status) {
          setMessage({
            ...message,
            open: true,
            color: "green",
            messageInfo: "Succès",
          });
          if (identif.desc === "Cons_ext") {
            navigate("/pretention_location");
            // setTimeout(function () {
            // }, 2500);
          } else if (identif.desc === "Cons_int") {
            navigate("/disponibilite");
          } else {
            navigate("/fichier");
          }
        } else {
          setMessage({
            ...message,
            open: true,
            color: "red",
            messageInfo: "Erreur",
          });
        }
      })
      .catch((err) => {
        setMessage({
          ...message,
          open: true,
          color: "red",
          messageInfo: "erreur",
        });
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const [identif, setIdentif] = useState({});
  const [modif, setModif] = useState({
    id: "",
    competence: "",
    type: "",
    niveau: "",
  });

  const handleChangemodif = (event) => {
    const { name, value } = event.target;
    setModif((prevModif) => ({
      ...prevModif,
      [name]: value,
    }));
  };

  const handleEdit = (index) => {
    setOpens(true);
    setIS(index);
    let result = compt.find((item) => item.id_competence === index);
    setModif({
      competence: result.competence,
      type: result.type,
      niveau: result.niveau,
      id: result.id_competence,
    });
  };

  const handleDelete = (index) => {
    Formservice.deletecompetence(index, ref).then((result) => {
      if (result && result.data) {
        setMessage({
          ...message,
          open: true,
          color: "green",
          messageInfo: "Succès",
        });
        Formservice.details(ref).then((result) => {
          if (result && result.data) {
            setIdentif(result.data);
            setCompt(result.autreep);
          } else {
          }
        });
      } else {
        setMessage({
          ...message,
          open: true,
          color: "red",
          messageInfo: "Erreur",
        });
      }
    });
  };

  useEffect(() => {
    Formservice.details(ref).then((result) => {
      if (result && result.data) {
        setIdentif(result.data);
        setCompt(result.autreep);
      } else {
      }
    });
  }, []);
  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }
  return (
    <Grid container style={{ display: "flex", justifyContent: "center" }}>
      <Message
        open={open}
        color={color}
        messageInfo={messageInfo}
        handleClose={handleCloseMessage}
      />
      <Menu />
      <header
        style={{
          height: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      ></header>
      <Grid
        item
        xs={12}
        md={10}
        lg={7}
        minHeight={"90vh"}
        borderRadius={"20px"}
        border={"2px rgba(11, 93, 208,0.5) solid "}
        boxShadow="0px 4px 10px rgba(7,71,161,0.4)"
        display={"flex"}
        flexDirection={"column"}
        p={2.5}
      >
        <main>
          <Grid container item xs={12} justifyContent={"center"}>
            <img
              src={logo}
              className="App-logo"
              alt="logo"
              style={{
                maxWidth: "75px",
                maxHeight: "75px",
                // marginLeft: "40%",
                // display: window.innerWidth <= 600 ? "block" : "none",
              }}
            />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Grid container item xs={12} justifyContent="center">
              <h1 style={{ marginBottom: "10px" }}>
                Autres compétences pertinentes{" "}
              </h1>
            </Grid>

            <Grid container justifyContent="center">
              <Grid item xs={12} md={6} style={{ marginBottom: "10px" }}>
                {/* <fieldset>
                  <legend>Identifiant</legend>
                  <label style={{ textAlign: "center" }}>
                    Référence du Dossier : {ref}
                  </label>
                  <br />
                  <label>Nom : {identif.nom}</label>
                  <br />
                  {prefix !== "CI" && <label>Poste : {identif.poste}</label>}
                  <br />
                </fieldset> */}
                <Identifiant identif={identif} prefix={prefix} refer={ref} />
              </Grid>

              <Grid
                item
                xs={12}
                md={6}
                style={{ marginBottom: "20px", color: "red" }}
              >
                {/* <fieldset>
                  <legend>NB</legend>
                  <label>- Tous les champs avec * sont obligatoires.</label>
                  <br />
                  <label>
                    - Le bouton Ajouter permet d'enregistrer les expériences.
                  </label>
                  <br />
                  <label>
                    - Veuillez cliquer sur suivant pour passer au suivant.
                  </label>
                </fieldset> */}
                <NB
                  texts={[
                    "Tous les champs avec * sont obligatoires",
                    "Veuillez cliquer sur suivant pour passer au suivant.",
                  ]}
                />
              </Grid>
            </Grid>

            {compt.length > 0 && (
              <TableContainer
                component={Paper}
                sx={{ width: { xs: "88vw", md: "78vw", lg: "54vw" } }}
                style={{
                  marginTop: "10px",
                  marginBottom: "20px",
                }}
              >
                <Table>
                  <TableHead>
                    <TableRow
                      style={{ backgroundColor: "gray", padding: "0px" }}
                    >
                      <TableCell align="center" colSpan={3}>
                        Autres compétences pertinentes{" "}
                      </TableCell>
                      <TableCell>Actions</TableCell>
                      {/* <TableCell>Niveau</TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {compt
                      .filter(
                        (data, index, self) =>
                          index ===
                          self.findIndex(
                            (t) =>
                              t.competence === data.competence &&
                              t.type === data.type &&
                              t.niveau === data.niveau
                          )
                      )
                      .map((data, index) => (
                        <TableRow key={index}>
                          <TableCell>{data.competence}</TableCell>
                          <TableCell>{data.type}</TableCell>
                          <TableCell>{data.niveau}</TableCell>
                          <TableCell>
                            <IconButton
                              aria-label="delete"
                              color="primary"
                              onClick={() => handleEdit(data.id_competence)}
                            >
                              <CreateTwoTone />
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              color="secondary"
                              onClick={() => handleDelete(data.id_competence)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            <TableContainer
              component={Paper}
              sx={{ width: { xs: "88vw", md: "78vw", lg: "54vw" } }}
              style={{
                marginTop: "10px",
                marginBottom: "20px",
              }}
            >
              <Table>
                <TableHead>
                  <TableRow style={{ backgroundColor: "gray", padding: "0px" }}>
                    <TableCell align="center" colSpan={3}>
                      Autres compétences pertinentes{" "}
                    </TableCell>
                    {/* <TableCell></TableCell>
                                <TableCell></TableCell>               */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {languages.map((langue, index) => (
                    <TableRow key={index}>
                      {index === 0 && (
                        <TableCell
                          rowSpan={
                            languages.filter(
                              (l) => l.competence === langue.competence
                            ).length
                          }
                        >
                          {langue.competence}
                        </TableCell>
                      )}
                      <TableCell>{langue.type}</TableCell>
                      <TableCell style={{ alignItems: "center" }}>
                        <input
                          type="checkbox"
                          checked={langue.lire}
                          onChange={() => handleCheckboxChange(index, "lire")}
                        />
                        Lire
                        <input
                          type="checkbox"
                          checked={langue.ecrire}
                          onChange={() => handleCheckboxChange(index, "ecrire")}
                        />
                        Ecrire
                        <input
                          type="checkbox"
                          checked={langue.parler}
                          onChange={() => handleCheckboxChange(index, "parler")}
                        />
                        Parler
                      </TableCell>
                    </TableRow>
                  ))}

                  {informatique.map((ifs, index) => (
                    <TableRow key={index}>
                      {index === 0 && (
                        <TableCell
                          rowSpan={
                            informatique.filter(
                              (l) => l.competence === ifs.competence
                            ).length
                          }
                        >
                          {ifs.competence}
                        </TableCell>
                      )}
                      <TableCell>{ifs.type}</TableCell>
                      <TableCell style={{ alignItems: "center" }}>
                        <input
                          type="checkbox"
                          checked={ifs.Excelent}
                          onChange={() =>
                            handleCheckboxChangeinfo(index, "Excellent")
                          }
                        />
                        Excellent
                        <input
                          type="checkbox"
                          checked={ifs.Moyen}
                          onChange={() =>
                            handleCheckboxChangeinfo(index, "Moyen")
                          }
                        />
                        Moyen
                        <input
                          type="checkbox"
                          checked={ifs.Débutant}
                          onChange={() =>
                            handleCheckboxChangeinfo(index, "Débutant")
                          }
                        />
                        Débutant
                      </TableCell>
                    </TableRow>
                  ))}
                  {rows.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <TextField
                          name={`domaine${index + 1}`} // Nom du champ pour l'identification
                          placeholder="Autre domaine"
                          size="small"
                          multiline
                          rows={5}
                          value={row.domaine}
                          onChange={(e) =>
                            handleChange(index, "domaine", e.target.value)
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          name={`competence${index + 1}`} // Nom du champ pour l'identification
                          placeholder="Compétence"
                          size="small"
                          multiline
                          rows={5}
                          value={row.competence}
                          onChange={(e) =>
                            handleChange(index, "competence", e.target.value)
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          name={`niveau${index + 1}`} // Nom du champ pour l'identification
                          placeholder="Niveau"
                          size="small"
                          multiline
                          rows={5}
                          value={row.niveau}
                          onChange={(e) =>
                            handleChange(index, "niveau", e.target.value)
                          }
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          <Grid
            item
            mt={3}
            mb={3}
            display={"flex"}
            justifyContent={"space-between"}
          >
            <Button variant="outlined" onClick={handleretour}>
              Retour
            </Button>
            <LoadingButton
              loading={submitting}
              variant="outlined"
              sx={{ marginLeft: "auto" }}
              onClick={handleenvoie}
              color="primary"
            >
              Suivant
            </LoadingButton>
          </Grid>
          <Dialog open={opens} onClose={handleClose} maxWidth="sm">
            <DialogTitle>Modification</DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                required
                margin="dense"
                id="name"
                name="competence"
                value={modif.competence}
                label="Competence"
                fullWidth
                size="small"
                variant="standard"
                onChange={handleChangemodif}
              />

              <TextField
                autoFocus
                required
                margin="dense"
                id="name"
                name="type"
                value={modif.type}
                label="type"
                fullWidth
                variant="standard"
                onChange={handleChangemodif}
              />
              <TextField
                autoFocus
                required
                margin="dense"
                id="name"
                name="niveau"
                value={modif.niveau}
                label="niveau"
                fullWidth
                variant="standard"
                onChange={handleChangemodif}
              />
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" color="primary" onClick={handleClose}>
                Annuler
              </Button>
              <Button variant="outlined" color="primary" onClick={handleUp}>
                Modifier
              </Button>
            </DialogActions>
          </Dialog>
        </main>
        <footer
          style={{
            color: "#0747a1",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          &copy; {new Date().getFullYear()} FID - FONDS D'INTERVENTION POUR LE DEVELOPPEMENT
        </footer>
      </Grid>
    </Grid>
  );
}

export default Competence;
